import { AxiosPromise } from 'axios';

import { api } from 'api';
import { BalanceCurrency } from 'features/app/ts/BalanceCurrency';
import { OutputBrandedGC } from 'features/app/ts/OutputBrandedGC';

export const getBalanceRequest = (): AxiosPromise<BalanceCurrency[]> => api.get(`/partners/balance/`);

export const getBrandedGiftCards = ({
  page_size,
  page,
  searchValue: product_name,
}: {
  page_size: number;
  page: number;
  searchValue?: string;
}): AxiosPromise<{ result: OutputBrandedGC[]; count: number }> =>
  api.get('/giftcards/branded-gift-cards/', { params: { page_size, page, product_name } });
